(function () {
    'use strict';

    angular.module("imApp").factory("capTaskResourceService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2067,
                    parameters: parms || {}
                });
            },
            newStatus: function (edit) {
                return $ihttp.post({
                    method: 2068,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
